var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabular-header',_vm._b({staticClass:"q-py-lg text-white",attrs:{"columns":_vm.columns},scopedSlots:_vm._u([{key:"cell-created_at-value",fn:function(ref){
var value = ref.value;
return [_c('date-tooltipped',{attrs:{"iso-date":value,"default-text":"ندارد"}})]}},{key:"cell-last_login_at-value",fn:function(ref){
var value = ref.value;
return [_c('date-tooltipped',{attrs:{"iso-date":value,"default-text":"ندارد"}})]}},{key:"cell-roles-value",fn:function(ref){
var value = ref.value;
return [_c('div',{staticClass:"full-width row justify-center"},[_c('text-ellipsis',{staticClass:"max-width-100 text-center",attrs:{"text":value}})],1)]}},{key:"cell-actions-value",fn:function(ref){
var value = ref.value;
return [_c('div',{staticClass:"row q-gutter-sm justify-end"},[_c('admin-user-switch-button',{attrs:{"user-id":value}})],1)]}}])},'tabular-header',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }